export default __webpack_public_path__ + "static/walletconnect-7d55c21bcf6162c3cc30a277abad24a0.png";